import React from 'react';
import Link from '../../elements/Link';

export default class ExtraProfileItem extends React.Component {
    render() {
        let {item, event, i18n} = this.props;

        let value = (item.value || []).map((value, i) => {
            if (item.exhibitor_backrefs) {
                if (item.exhibitor_backrefs[value]) {
                    return (
                        <Link
                            className="smallButton marginTop marginBottom"
                            style={event._local.styles.smallButton}
                            href={['/events', event.id, 'exhibitors', item.exhibitor_backrefs[value]].join('/')}
                            key={i}>
                            <b>{value}</b>
                        </Link>
                    );
                }
            }
            switch (item.type) {
                case 'email':
                    return (
                        <a
                            className="smallButton marginTop marginBottom"
                            style={event._local.styles.smallButton}
                            target="blank"
                            href={'mailto:' + value}
                            key={i}>
                            <b>{value}</b>
                        </a>
                    );
                case 'phone':
                    return (
                        <a className="smallButton marginTop marginBottom" style={event._local.styles.smallButton} target="blank" href={'tel:' + value} key={i}>
                            <b>{value}</b>
                        </a>
                    );
                case 'link':
                    return (
                        <a className="smallButton marginTop marginBottom" style={event._local.styles.smallButton} target="blank" href={value} key={i}>
                            <b>{value}</b>
                        </a>
                    );
                default:
                    return (
                        <span key={i}>
                            {value}
                            <br />
                        </span>
                    );
            }
        });
        return (
            <p>
                <b
                    style={{
                        color: event.settings.primary_color,
                    }}>
                    {item.name}
                </b>
                <br />
                <span className="text main">{value}</span>
            </p>
        );
    }
}
